import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import {useTranslation} from "react-i18next";
import {ServerTablePrintColumnLayout} from "./types";

/** A column the picker offers: the table's column id and its header text. */
type ServerTableColumnPickerOption = Pick<ServerTablePrintColumnLayout, 'id' | 'label'>;

interface ServerTablePrintColumnPickerProps {
    columns: ServerTableColumnPickerOption[]
    selectedColumnIds: string[]
    onChange: (columnIds: string[]) => void
    /** The field label; "Print columns" by default. The export dialog picks its columns with the same field. */
    label?: string
    /** Shown under the field in the error color. */
    error?: string
}

export function ServerTablePrintColumnPicker({
    columns,
    selectedColumnIds,
    onChange,
    label,
    error
}: ServerTablePrintColumnPickerProps) {
    const {t} = useTranslation();
    // Chips follow print order rather than column-definition order.
    const selectedColumns = selectedColumnIds
        .map(id => columns.find(column => column.id === id))
        .filter((column): column is ServerTableColumnPickerOption => Boolean(column));

    return (
        <Autocomplete
            multiple
            disableCloseOnSelect
            size="small"
            options={columns}
            value={selectedColumns}
            getOptionLabel={option => option.label}
            isOptionEqualToValue={(option, value) => option.id === value.id}
            onChange={(_event, value) => onChange(value.map(column => column.id))}
            renderInput={params => (
                <TextField
                    {...params}
                    label={label ?? t('Print columns')}
                    error={Boolean(error)}
                    helperText={error}
                />
            )}
        />
    );
}
